import { useField } from "formik";
import React from "react";
import DatePicker, {ReactDatePickerProps} from "react-datepicker";
import { Form, Label } from "semantic-ui-react";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import "./style_form.css";

interface Props {
    placeholder: string;
    name: string;
    type?: string;
    label?: string;
    value?: any;
    id?: string;
    className?: string;
    maxlength?: any;
    defaultValue?: any;

    onChange?: any;
    onInput?: any;
    disabled?: any;
}

export default function MyDateInput(props: Partial<ReactDatePickerProps>) {
    const [field, meta, helpers] = useField(props.name!);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <DatePicker
                {...field} 
                {...props}
                selected={(field.value && new Date(field.value)) || null}
                onChange={value => helpers.setValue(value)}
                showYearDropdown
            />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ): null}
        </Form.Field>
    )
}